// extracted by mini-css-extract-plugin
export var resizer = "_hi-0";